import React from "react";

export function StatusPill({ status, className = "" }) {
  const map = {
    submitted: "bg-blue-50 text-blue-700",
    approved: "bg-emerald-100 text-emerald-800",
    rejected: "bg-rose-100 text-rose-800",
    clarification_requested: "bg-amber-100 text-amber-800",
    verified: "bg-emerald-100 text-emerald-800",
    in_review: "bg-amber-100 text-amber-800",
    pending: "bg-slate-100 text-slate-700",
    invited: "bg-blue-50 text-blue-700",
    rejected: "bg-rose-100 text-rose-800",
    requested: "bg-blue-50 text-blue-700",
    customer_approved: "bg-indigo-100 text-indigo-800",
    propay_approved: "bg-violet-100 text-violet-800",
    paid: "bg-emerald-100 text-emerald-800",
    completed: "bg-emerald-100 text-emerald-800",
    issued: "bg-blue-50 text-blue-700",
    offer_sent: "bg-blue-50 text-blue-700",
    countered: "bg-amber-100 text-amber-800",
    accepted: "bg-emerald-50 text-emerald-700",
    contracted: "bg-indigo-50 text-indigo-700",
    active: "bg-emerald-100 text-emerald-800",
    closed: "bg-slate-100 text-slate-600",
    open: "bg-blue-50 text-blue-700",
    executed: "bg-emerald-100 text-emerald-800",
    pending_signatures: "bg-amber-100 text-amber-800",
  };
  const cls = map[status] || "bg-slate-100 text-slate-700";
  const label = (status || "").replace(/_/g, " ");
  return <span className={`status-pill ${cls} ${className}`}>{label}</span>;
}

export function KPI({ label, value, hint, icon: Icon, tone = "default", ...rest }) {
  const tones = {
    default: "text-slate-900",
    blue: "text-[#0052FF]",
    green: "text-emerald-600",
    amber: "text-amber-600",
  };
  return (
    <div {...rest} className="hover-lift bg-white rounded-xl border border-slate-200 p-5">
      <div className="flex items-center justify-between text-slate-500 text-xs uppercase tracking-widest">
        <span className="font-semibold">{label}</span>
        {Icon ? <Icon size={16} /> : null}
      </div>
      <div className={`mt-3 text-3xl font-heading font-bold ${tones[tone]}`}>{value}</div>
      {hint ? <div className="mt-1 text-xs text-slate-500">{hint}</div> : null}
    </div>
  );
}

export function AppLogo({ dark = false, className = "", size = "md" }) {
  const heights = { sm: "h-6", md: "h-8", lg: "h-10" };
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="https://customer-assets.emergentagent.com/job_influencer-pay-6/artifacts/z75omco3_ProPay%20Logo.png"
        alt="ProPay.ai"
        className={`${heights[size]} w-auto ${dark ? "" : "invert"} select-none`}
        draggable={false}
      />
    </div>
  );
}

export function Section({ title, subtitle, children, right }) {
  return (
    <section className="space-y-4">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {right}
      </div>
      {children}
    </section>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="border-2 border-dashed border-slate-200 rounded-xl p-10 text-center bg-white">
      <div className="font-heading text-lg font-semibold text-slate-800">{title}</div>
      {hint && <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
